import * as angular from 'angular';
import template from './mx-try-new-look-action.html';
import type { ActionExecutorService } from '../../../services/mx-action-executor-service';
import type { MxAction } from '../../../model/action';
import type { PersonalizationService } from '../../../../../App/services/personalization-service';

class MxTryNewLookActionCtrl {
	action!: MxAction;

	withAnimation = false;

	static $inject = ['mx.shell.ActionExecutorService', 'mx.SolutionBuilderAgent.PersonalizationService'];
	constructor(
		private readonly actionExecutorService: ReturnType<typeof ActionExecutorService>,
		private readonly personalizationService: ReturnType<typeof PersonalizationService>
	) {}

	$onInit() {
		this.action.ignoreConfirmationForServiceOperation = true;
		this.personalizationService.getTryNewLookActionData().then((alreadyTried) => {
			this.withAnimation = !alreadyTried;
		});
	}

	async execute() {
		await this.personalizationService.setTryNewLookActionData(true);
		this.actionExecutorService.execute(this.action);
	}
}

angular.module('mx.shell').component('mxTryNewLookAction', {
	bindings: {
		action: '<action',
	},
	controller: MxTryNewLookActionCtrl,
	controllerAs: 'vm',
	template,
});
